import CryptoJS from 'crypto-js'
import { format } from 'date-fns'

const buildPassphrase = () => {
  const date = format(new Date(), 'yyyyMMdd')
  const passphraseStr = `${date}${date}`
  return passphraseStr
}

export const decryptAesCredentials = cipherText => {
  const parsedHash = CryptoJS.enc.Base64.parse(cipherText)

  const passphrase = buildPassphrase()
  const key = CryptoJS.enc.Utf8.parse(passphrase)

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: parsedHash }, key, {
    iv: key,
  })

  const parsedDecrypted = decrypted.toString(CryptoJS.enc.Utf8)

  if (!parsedDecrypted) return undefined

  const [user, password] = parsedDecrypted.split('|')
  return { user, password }
}

export const getMD5hash = plainText => CryptoJS.MD5(plainText).toString()
